import React from 'react';
import * as componentStyle from './caseStudyDesignHighlights.module.scss';
import { Heading } from '../../../interface/header.interface';
import { GatsbyImageInterface } from '../../../interface/image.interface';
import HeadingComponent from '../../HeadingComponent/HeadingComponent';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';



interface ImageInterafce {
  image: GatsbyImageInterface | null;
  altText: string | null;
}
interface ContextInterface {
  heading: string | null;
  description?: string | null;
  descriptionTwo?: string | null;
  sectionImage: ImageInterafce | null;
}
export interface CaseStudyHighlightsProps {
  heading: Heading[] | null;
  description?: string | null;
  descriptionTwo: string | null;
  sectionImage: ImageInterafce | null;
  context: ContextInterface | null;
}

export default function CaseStudyDesignHighlights({ data }: { data: CaseStudyHighlightsProps | null }) {
  return (
    <>
      {(data?.heading && !data?.descriptionTwo) && (
        <section className={componentStyle.caseStudyDesignHighlights}>
          <div className={componentStyle.caseStudyDesignHighlights__topSection}>
            <div className={componentStyle.caseStudyDesignHighlights__container}>
              <div className={componentStyle.caseStudyDesignHighlights__headingArea}>
                {data?.heading && <HeadingComponent data={data?.heading} textAlign='center' />}
                {data?.description && <div className={componentStyle.caseStudyDesignHighlights__description} dangerouslySetInnerHTML={{ __html: data?.description }}></div>}
              </div>
              <div className={componentStyle.caseStudyDesignHighlights__topContext}>
                {data?.sectionImage?.image && 
                  <div className={componentStyle.caseStudyDesignHighlights__topContextImage}>
                    <GatsbyImage image={getImage(data?.sectionImage?.image?.localFile) as IGatsbyImageData} alt={data?.sectionImage?.altText || 'N/A'}  />
                  </div>
                }
                {data?.descriptionTwo && <div className={componentStyle.caseStudyDesignHighlights__topContextDescription} dangerouslySetInnerHTML={{ __html: data?.descriptionTwo }}></div>}
              </div>
            </div>
          </div>

          {data?.context?.heading && (
            <div className={componentStyle.caseStudyDesignHighlights__bottomSection}>
              <div className={componentStyle.caseStudyDesignHighlights__container}>
                <div className={componentStyle.caseStudyDesignHighlights__bottomHeadingArea}>
                  <h4 className={componentStyle.caseStudyDesignHighlights__bottomHeading}>{data?.context?.heading}</h4>
                </div>

                {data?.context?.sectionImage?.image && 
                  <div className={componentStyle.caseStudyDesignHighlights__bottomImage}>
                    <GatsbyImage image={getImage(data.context.sectionImage.image.localFile) as IGatsbyImageData} alt={data.context.sectionImage.altText || 'N/A'} />
                  </div>
                }
              </div>
            </div>
          )}
        </section>
      )}

      {/* -----===== Design Highlights V2 =====----- */}
      {(data?.heading && data?.descriptionTwo) && (
        <section className={componentStyle.caseStudyDesignHighlightsV2}>
          <div className={componentStyle.caseStudyDesignHighlightsV2__topSection}>
            <div className={componentStyle.caseStudyDesignHighlightsV2__container}>
              {data?.heading &&
                <div className={componentStyle.caseStudyDesignHighlightsV2__headingArea}>
                  <HeadingComponent data={data?.heading} textAlign='center' />
                </div>
              }
              <div className={componentStyle.caseStudyDesignHighlightsV2__topContext}>
                {data?.sectionImage?.image && 
                  <div className={componentStyle.caseStudyDesignHighlightsV2__topContextImage}>
                    <GatsbyImage image={getImage(data?.sectionImage?.image?.localFile) as IGatsbyImageData} alt={data?.sectionImage?.altText || 'N/A'} />
                  </div>
                }
                <div className={componentStyle.caseStudyDesignHighlightsV2__topContextDescription} dangerouslySetInnerHTML={{ __html: data?.descriptionTwo || <p>N/A</p> }}></div>
              </div>
            </div>
          </div>

          {data?.context?.heading && (
            <div className={componentStyle.caseStudyDesignHighlightsV2__bottomSection}>
              <div className={componentStyle.caseStudyDesignHighlightsV2__container}>
                <div className={componentStyle.caseStudyDesignHighlightsV2__bottomHeadingArea}>
                  <div className={componentStyle.caseStudyDesignHighlightsV2__bottomHeadingContext}>
                    <h4 className={componentStyle.caseStudyDesignHighlightsV2__bottomHeading}>{data?.context?.heading}</h4>
                    {data?.context?.description && 
                      <div 
                        className={componentStyle.caseStudyDesignHighlightsV2__bottomHeadingDescription} 
                        dangerouslySetInnerHTML={{ __html: data.context.description }}>
                      </div>
                    }
                  </div>

                  {data?.context?.descriptionTwo && 
                    <div 
                      className={`${componentStyle.caseStudyDesignHighlightsV2__topContextDescription} ${componentStyle.caseStudyDesignHighlightsV2__bottomDescription}`} 
                      dangerouslySetInnerHTML={{ __html: data?.context?.descriptionTwo }}
                    ></div>
                  }
                </div>

                {data?.context?.sectionImage?.image && 
                  <div className={componentStyle.caseStudyDesignHighlightsV2__bottomImage}>
                    <GatsbyImage image={getImage(data.context.sectionImage.image.localFile) as IGatsbyImageData} alt={data.context.sectionImage.altText || 'N/A'} />
                  </div>
                }
              </div>
            </div>
          )}
        </section>
      )}
    </>
  )
}
